import { Select, type SelectProps } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiFetch } from "../api/client.js";

interface User { id: number; name: string; email: string; initials: string | null }

interface Props extends Omit<SelectProps, "data" | "value" | "onChange"> {
    value: number | null;
    onChange: (id: number | null) => void;
}

export function UserSelect({ value, onChange, ...rest }: Props) {
    const { t } = useTranslation();
    const { data } = useQuery({
        queryKey: ["users"],
        queryFn: () => apiFetch<{ items: User[] }>("/api/users"),
        staleTime: 60_000,
    });
    const options = (data?.items ?? []).map((u) => ({
        value: String(u.id),
        label: `${u.name}${u.initials ? ` (${u.initials})` : ""}`,
    }));
    return (
        <Select
            data={options}
            value={value == null ? null : String(value)}
            onChange={(v) => onChange(v == null ? null : Number(v))}
            searchable
            clearable
            nothingFoundMessage={t("users.select.nothingFound")}
            {...rest}
        />
    );
}
